import { AxiosError } from 'axios'
import { logout } from '../services/auth'

export const verifyAuthenticatedUser = (error: AxiosError) => {
  if (error.response?.status === 401) {
    logout()
  }
  return Promise.reject(error)
}
